import { Fragment } from 'react';

/** Stepper numerado horizontal (desktop) — onboarding do médico. */
export default function Stepper({ steps, current, onSelect }: { steps: string[]; current: number; onSelect?: (step: number) => void }) {
  return (
    <nav className="stepper" aria-label="Etapas">
      {steps.map((s, i) => {
        const n = i + 1;
        const state = n < current ? 'done' : n === current ? 'cur' : '';
        return (
          <Fragment key={s}>
            {i > 0 && <span className="bar" />}
            <button type="button" className={`st ${state}`} style={{ background: 'none', border: 0 }} disabled={!onSelect || n > current} onClick={() => onSelect?.(n)} aria-current={n === current ? 'step' : undefined}>
              <b>{n < current ? '✓' : n}</b>{s}
            </button>
          </Fragment>
        );
      })}
    </nav>
  );
}
